import React, {Component} from 'react'
import ScreenTemplate from 'shared/components/ScreenTemplate'
import {Tab, TabContent, TabNavItem, Tabs} from '@sabre/spark-react'
import Header from './Header'
import Products from '../products/index'
import FlightWeather from '../weather/index'

export default class Briefing extends Component {
    titleReturnToFlights = 'Return to flights'
    pageHeader = 'Briefing for flight:'

    componentDidMount() {
        this.props.actions.getFlightInfo(this.props.match.params.flightId)
    }

    componentWillUnmount() {
        this.props.actions.resetError()
    }

    render() {
        const message = this.props.error
            ? {type: "warning", title: this.props.error.title, text: this.props.error.text}
            : undefined
        const flightCallsign = this.props.flightInfo
            ? `${this.props.flightInfo.Prefix.icao} ${this.props.flightInfo.Number}`
            : ''
        return (
            <ScreenTemplate
                login={this.props.username !== undefined ? this.props.username : 'unknown'}
                activeMenuItem="Briefing"
                message={message}>
                <Header backHref='/flights' backTitle={this.titleReturnToFlights}
                        text={`${this.pageHeader} ${flightCallsign}`}/>
                <div className="col-xs-12">
                    <Tabs>
                        <Tab>
                            <TabNavItem icon="documents">Briefing</TabNavItem>
                            <TabContent className="white-bg min-height-600">
                                <Products/>
                            </TabContent>
                        </Tab>
                        <Tab>
                            <TabNavItem icon="weather-day-cloudy">Weather</TabNavItem>
                            <TabContent className="white-bg min-height-600">
                                <FlightWeather/>
                            </TabContent>
                        </Tab>
                    </Tabs>
                </div>
            </ScreenTemplate>
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/briefing/components/index.js